import PropTypes from 'prop-types';
import styles from './style.module.scss';
import { Row, Col, Modal, Form, Input, Select } from 'antd';
import { DeleteIcon } from 'icons';
import { Button } from 'components';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import FormHelper from '../../../../../../helpers/FormHelper';
import React from 'react';
import UIHelper from '../../../../../../helpers/UIHelper';
import { useNavigate } from '../../../../../../hooks/useNavigate';
import { useLocation, useParams } from 'react-router-dom';

const EditModal = ({
  show = true,
  description,
  loading,
  form,
  premisionsGroups,
  handleCreateRole,
  isEdit,
}) => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { pathname } = useLocation();
  const { id } = useParams();
  const onFinish = async (values) => {
    handleCreateRole(values);
  };

  const handleCancel = () => {
    if (id) {
      history(UIHelper.getListRoute(pathname));
    } else {
      history(UIHelper.getListRoute(pathname, 1));
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  return (
    <Modal width={410} visible={show} onCancel={handleCancel} footer={false}>
      <div className={styles.modalContent}>
        <div className={styles.title}>
          {isEdit ? t('Modifica') : t('Nuovo')}
        </div>
        <span className={styles.description}>{description}</span>

        <Row gutter={14} className={styles.row}>
          <Col span={24}>
            <Form
              form={form}
              name='basic'
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                title: '',
              }}
              layout={'vertical'}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
              onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
            >
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label={t('Nome')} name={'title'}>
                    <Input size={'large'} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col>
            <Button loading={loading} onClick={onClickSave} width={'326px'} big>
              {isEdit ? t('Salva') : t('Aggiungere')}
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

EditModal.propTypes = {
  onClickOk: PropTypes.func,
  onCancel: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  description: PropTypes.string,
  yesBtnText: PropTypes.string,
  noBtnText: PropTypes.string,
  show: PropTypes.bool,
  type: PropTypes.oneOf(['delete', 'info']),
  loading: PropTypes.bool,
};

export default EditModal;
